import React from 'react';
import { BrowserRouter as Router, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import LoginForm from './components/Auth/LoginForm';
import Dashboard from './components/Dashboard/Dashboard';
import ClientiPage from './components/Clienti/ClientiPage';
import ContractePage from './components/Contracte/ContractePage';
import MonitorizarePage from './components/Monitorizare/MonitorizarePage';
import MonitoringRunPage from './components/Monitoring/MonitoringRunPage';
import Sidebar from './components/Layout/Sidebar';
import Header from './components/Layout/Header';
import './App.css';

function ProtectedLayout() {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="app-main">
        <div className='app-wrapper'>
        <Header />
        <main className="app-content">
          <Outlet />
        </main>
          
        </div>
      </div>
    </div>
  );
}

function AppContent() {
  const { user } = useAuth();

  return (
    <Router>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginForm />} />
        <Route path="/" element={<ProtectedLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="clienti" element={<ClientiPage />} />
          <Route path="contracte" element={<ContractePage />} />
          <Route path="monitorizare" element={<MonitorizarePage />} />
          <Route path="ruleaza-monitoring" element={<MonitoringRunPage />} />
          <Route path="monitorizare/run" element={<Navigate to="/ruleaza-monitoring" replace />} />
        </Route>
        <Route path="*" element={<Navigate to={user ? '/' : '/login'} replace />} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;